import { useState } from 'react';

import {
  COUNTRY_OPTIONS,
  DEFAULT_COUNTRY_CODE,
  formatPhoneByMask,
  isPhoneLengthComplete,
  normalizePhoneInput,
  resolveCountryOption,
  sanitizePhoneDigits,
  type CountryCode,
  type CountryOption,
} from '../../../shared/model';

export type TipCheckoutPayerContactForm = {
  clearPhone: () => void;
  countryCode: CountryCode;
  countryFlag: string;
  countryOptions: ReadonlyArray<CountryOption>;
  isPhoneComplete: boolean;
  phoneNumber: string | null;
  phone: string;
  phoneMask: string;
  selectCountryCode: (country: CountryCode) => void;
  setPhone: (value: string) => void;
};

export function useTipCheckoutPayerContactForm(): TipCheckoutPayerContactForm {
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY_CODE);
  const [phone, setPhoneState] = useState('');
  const phoneDigits = sanitizePhoneDigits(phone);
  const selectedCountry = resolveCountryOption(countryCode);
  const isPhoneComplete = isPhoneLengthComplete(phoneDigits.length);

  const selectCountryCode = (nextCountryCode: CountryCode) => {
    setCountryCode(nextCountryCode);
    setPhoneState(formatPhoneByMask(phoneDigits, nextCountryCode));
  };

  const setPhone = (value: string) => {
    const { countryCode: nextCountryCode, phoneDigits: nextPhoneDigits } =
      normalizePhoneInput(value, countryCode);

    setCountryCode(nextCountryCode);
    setPhoneState(formatPhoneByMask(nextPhoneDigits, nextCountryCode));
  };

  const clearPhone = () => {
    setPhoneState('');
  };

  return {
    clearPhone,
    countryCode,
    countryFlag: selectedCountry.flag,
    countryOptions: COUNTRY_OPTIONS,
    isPhoneComplete,
    phoneNumber: isPhoneComplete ? `${countryCode}${phoneDigits}` : null,
    phone,
    phoneMask: selectedCountry.mask,
    selectCountryCode,
    setPhone,
  };
}
